import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {EventClickInfo, FullCalendarComponent, FullCalendarModule} from '@fullcalendar/angular';
import {CalendarOptions} from "@fullcalendar/angular"
import dayGridPlugin from "@fullcalendar/angular/daygrid"
import timeGridPlugin from "@fullcalendar/angular/timegrid"
import interactionPlugin from "@fullcalendar/angular/interaction"
import deLocale from "@fullcalendar/angular/locales/de"
import {CommonModule, CurrencyPipe, DatePipe} from '@angular/common';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatCheckbox} from '@angular/material/checkbox';
import {Router} from '@angular/router';
import {DoctorModel} from '../../../models/doctor/doctor.model';
import {PatientModel} from '../../../models/patient/patient.model';
import {AppointmentModel, ReservedAppointmentModel} from '../../../models/appointment/appointment.model';
import {PharmacyModel} from '../../../models/pharmacy/pharmacy.model';
import {AppointmentService} from '../../../services/appointment/appointment.service';
import {PatientService} from '../../../services/patient/patient.service';
import {InfoMessageService} from '../../../services/infomessage/infomessage.service';
import {AuthenticationService} from '../../../services/authentication/authentication.service';
import {AppointmentConfirmModel} from '../../../models/appointment-confirm/appointment-confirm.model';
import {QueryModel} from '../../../services/http/http.service';
import {iResponse, iResponseList} from '../../../models/response/response.model';
import {AppointmentEventModel} from '../../../models/appointment-events/appointment-event.model';
import {MatDialog} from "@angular/material/dialog";
import {UploadService} from '../../../services/upload/upload.service';
import {ConfirmDialogComponent} from '../../confirm-dialog/confirm-dialog.component';
import {ReserveModel} from '../../../models/reserve/reserve.model';
import {BrowserStorageService} from '../../../services/browser-storage/browser-storage.service';
import themePlugin from '@fullcalendar/angular/themes/classic'
import {BreakpointObserver} from '@angular/cdk/layout';

@Component({
    selector: 'app-appointment-booking-details',
    standalone: true,
    imports: [
        CommonModule,
        FullCalendarModule,
        DatePipe,
        FormsModule,
        ReactiveFormsModule,
        MatCheckbox,
        CurrencyPipe
    ],
    templateUrl: './appointment-booking-details.component.html',
    styleUrl: './appointment-booking-details.component.sass',
    providers: [BrowserStorageService]
})
export class AppointmentBookingDetailsComponent implements OnInit, OnDestroy {
    @ViewChild('calendar')
    calendarComponent!: FullCalendarComponent;
    private destroy$: Subject<void> = new Subject<void>();

    // Calendar logic
    now = new Date();
    hours = this.now.getHours().toString().padStart(2, '0');
    minutes = this.now.getMinutes().toString().padStart(2, '0');

    calendarOptions: CalendarOptions = {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, themePlugin],
        initialDate: this.now,
        scrollTime: `${this.hours}:${this.minutes}:00`,
        headerToolbar: {
            left: 'prev',
            center: 'title',
            right: 'next'
        },
        allDaySlot: false,
        locale: deLocale,
        eventClass: () => {
            return 'appointment';
        },
        slotHeaderFormat: {
            hour: '2-digit',
            minute: '2-digit',
            omitZeroMinute: false,
            meridiem: false,
            hour12: false
        },
        dayHeaderFormat: {
            weekday: 'short',
            day: '2-digit',
            month: 'numeric',
            omitCommas: true
        },
        eventTimeFormat: {
            hour: '2-digit',
            minute: '2-digit',
            meridiem: true,
            hour12: false
        },
        displayEventEnd: false,
        displayEventTime: true,
        eventColor: '#314B3A',
        eventClick: (clickInfo: EventClickInfo) => {
            const getStart = clickInfo.event.startStr
            const getEnd = clickInfo.event.endStr
            const start = new Date(getStart).toISOString();
            const end = new Date(getEnd).toISOString();
            if (this.selectedEventId === clickInfo.event.id) {
                clickInfo.event.setProp('color', '#314B3A')
                this.selectedEventId = null;
            } else {
                if (this.selectedEventId) {
                    let event = clickInfo.view.calendar.getEventById(this.selectedEventId);
                    if (event) {
                        event?.setProp('color', '#314B3A')
                    }
                }
                clickInfo.event.setProp('color', '#D6973C')
                this.selectedEventId = clickInfo.event.id;
            }
            console.log('selectedEventId', this.selectedEventId)
            if (this.selectedEventId) {
                this.selectedReservation = {
                    doctorId: clickInfo.event.extendedProps['doctorId'],
                    from: start,
                    to: end,
                    id: null
                }

            } else {
                this.selectedReservation = null;
            }
            clickInfo.jsEvent.preventDefault();
        },
    };

    selectedEventId: string | null = null;
    selectedReservation: ReserveModel | null = null;
    activeDoctor: DoctorModel | null = null;
    loggedInPatient: PatientModel | null = null;
    reservedAppointment: ReservedAppointmentModel | null = null;

    selectedPage: number = 1;
    dataProtectionAgreementAccepted: boolean = false;
    termsAndConditionsAccepted: boolean = false;
    dataConfirmDialogOpened: boolean = false;

    constructor(
        private appointmentService: AppointmentService,
        private patientService: PatientService,
        private infoMessageService: InfoMessageService,
        private authenticationService: AuthenticationService,
        private uploadService: UploadService,
        private router: Router,
        private dialog: MatDialog,
        private browserStorageService: BrowserStorageService,
        private breakpointObserver: BreakpointObserver
    ) {
        const navigation = this.router.currentNavigation();
        let doctor = navigation?.extras?.state?.['doctor'];

        if (!doctor && this.browserStorageService.hasObject('selectedDoctor')) {
            const storedDoctor = this.browserStorageService.get('selectedDoctor');
            if (storedDoctor) {
                doctor = JSON.parse(storedDoctor);
            }
        }

        if (doctor) {
            this.activeDoctor = doctor;
            this.initializeDoctor();
        } else {
            this.router.navigate(['termine/arztwahl']);
        }
    }

    ngOnInit(): void {
        this.getMe();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.reservedAppointment && this.reservedAppointment.id !== '') {
            this.cancelReservation(this.loggedInPatient?.id!, this.reservedAppointment.id);
        }
    }

    ngAfterViewInit() {
        this.breakpointObserver
            .observe('(max-width: 767px)')
            .subscribe(result => {

                const api = this.calendarComponent.getApi();

                if (result.matches) {
                    api.changeView('timeGridDay');
                } else {
                    api.changeView('timeGridWeek');
                }
            });
    }

    private getMe(): void {
        this.patientService.getMe()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<PatientModel>) => {
                    this.loggedInPatient = response.data;
                }
            });
    }

    initializeDoctor(): void {
        if (this.activeDoctor) {

            const duration = this.formatMinutesToTime(
                this.activeDoctor.consultingDurationInMinutes!
            );

            this.activeDoctor.calendarOptions = {
                ...this.calendarOptions,
                slotDuration: duration,
                datesSet: (dateInfo) => {
                    this.loadAppointmentsForDoctor(dateInfo.startStr, dateInfo.endStr);
                }
            };
        }
    }

    private formatMinutesToTime(minutes: number): string {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;

        return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:00`;
    }

    loadAppointmentsForDoctor(from: string, to: string): void {
        const query: QueryModel = {
            doctorId: this.activeDoctor?.id,
            from: from,
            to: to
        };
        this.getAppointments(query);
    }

    getAppointments(query: QueryModel): void {
        this.appointmentService.getAppointments(query)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponseList<AppointmentModel>) => {
                    if (this.activeDoctor) {
                        this.activeDoctor.mappedAppointments = this.parseAppointments(response.data);
                    }
                }
            });
    }

    parseAppointments(appointments: AppointmentModel[]): AppointmentEventModel[] {

        return appointments.flatMap(appointment => {
            return appointment.availableAppointments.map(availableAppointment => {
                const start = new Date(new Date(availableAppointment.from).getTime())
                const hours = start.getHours();
                const minutes = String(start.getMinutes()).padStart(2, '0');
                return {
                    id: appointment.doctor.id + availableAppointment.from,
                    // title: title,
                    start: availableAppointment.from,
                    end: availableAppointment.to,
                    backgroundColor: '#E3ECE4FF',
                    textColor: 'white',
                    doctorId: appointment.doctor.id,
                    allDay: false,
                }
            })
        })

        // const events: AppointmentEventModel[] = [];
        // appointments.forEach(appointment => {
        //     appointment.availableAppointments.forEach(availableAppointment => {
        //         events.push({
        //             id: availableAppointment.from,
        //             // title: 'Verfügbar',
        //             start: availableAppointment.from,
        //             end: availableAppointment.to,
        //             backgroundColor: '#E3ECE4FF',
        //             textColor: '#2E4A2FFF',
        //             // allDay: false,
        //             doctorId: availableAppointment..id!
        //         });
        //     });
        // });
        // return events;
    }

    toPage(page: number): void {
        if (page === 1) {
            if (this.reservedAppointment && this.reservedAppointment.id !== '') {
                this.cancelReservation(this.loggedInPatient?.id!, this.reservedAppointment.id);
            }
            this.selectedPage = page;
        }

        if (page === 2) {
            if (!this.selectedReservation) {
                this.infoMessageService.createMessage('Bitte treffen Sie eine Auswahl', 'info');
                return;
            }
            this.selectedPage = page;
            this.reserveAppointment(this.loggedInPatient?.id!, this.selectedReservation!);
        }

        if (page === 3) {
            if (!this.dataProtectionAgreementAccepted || !this.termsAndConditionsAccepted) {
                this.infoMessageService.createMessage('Bitte die Datenschutzbestimmungen und die AGBs akzeptieren', 'info');
                return;
            }

            let confirmModel: AppointmentConfirmModel = {
                confirmedByDoctor: false,
                confirmedByPatient: true,
                doctorId: this.activeDoctor!.id,
                from: this.reservedAppointment!.from,
                to: this.reservedAppointment!.to,
                id: this.reservedAppointment!.id,
                patient: this.loggedInPatient!,
                pharmacy: null as any,
                dataProtectionAgreementAccepted: this.dataProtectionAgreementAccepted,
                termsAndConditionsAccepted: this.termsAndConditionsAccepted,
            };
            this.confirmAppointment(this.loggedInPatient?.id!, this.reservedAppointment!.id, confirmModel);
        }
    }

    reserveAppointment(patientId: string, reserveModel: ReserveModel): void {
        this.patientService.reserveAppointment(patientId, reserveModel)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<ReservedAppointmentModel>) => {
                    this.reservedAppointment = response.data;
                }
            });
    }

    cancelReservation(patientId: string, appointmentId: string): void {
        this.patientService.cancelReservation(patientId, appointmentId)
            .pipe(takeUntil(this.destroy$))
            .subscribe();
    }

    openDataConfirmModel(): void {
        if (this.dataConfirmDialogOpened) {
            return;
        }
        this.dataConfirmDialogOpened = true;
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            closeOnNavigation: true,
            disableClose: false,
            data: {
                text: 'Möchten Sie, dass die in der Vergangenheit von Ihnen oder Ihren bisherigen Ärzten hochgeladenen Patientendaten auch dem neuen Arzt zur Verfügung gestellt werden? Für eine optimale Behandlung empfehlen wir dies.',
                header: 'Patientendaten freigeben',
                delete: false
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.uploadService.setFilePermissions('00000000-0000-0000-0000-000000000000', this.activeDoctor!.id)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                        next: (response: any) => {
                            this.infoMessageService.createMessage('Patientendaten erfolgreich freigegeben.', 'success');
                        },
                        error: (error) => {
                            this.infoMessageService.createMessage('Patientendaten konnten nicht freigegeben werden.', 'error');
                        }
                    });
            }
            this.dataConfirmDialogOpened = false;
        });
    }

    confirmAppointment(patientId: string, appointmentId: string, confirmModel: AppointmentConfirmModel): void {
        this.patientService.confirmAppointment(patientId, appointmentId, confirmModel)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: any) => {
                    this.infoMessageService.createMessage('Termin erfolgreich gebucht', 'success');
                    this.reservedAppointment = null; // Prevent cancelReservation on OnDestroy
                    this.browserStorageService.remove('selectedDoctor');
                    this.router.navigate(['termine']);
                },
                error: (error) => {
                    this.selectedPage = 1
                    this.infoMessageService.createMessage('Termin konnte nicht bestätigt werden', 'error');
                }
            });
    }

    toDoctorSelect(): void {
        this.browserStorageService.remove('selectedDoctor');
        this.router.navigate(['termine/arztwahl']);
    }

    toDataProtectionSite(): void {
        const url = this.router.serializeUrl(this.router.createUrlTree(['/datenschutz']));
        window.open(url, '_blank');
    }

    toAgbsPage(): void {
        const url = this.router.serializeUrl(this.router.createUrlTree(['/agb']));
        window.open(url, '_blank');
    }
}
